import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { createStructuredSelector } from 'reselect'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { toastTitleSelector, toastMessageSelector, toastTimeSelector, toastVariantSelector } from '../selectors/toasterSelectors'

const Toast = ({ closeToast, title, message, variant, time }) => {
  const [timestamp, setTimestamp] = useState(moment(time).fromNow())

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimestamp(moment(time).fromNow())
    }, 5000)

    return () => {
      clearInterval(intervalId)
    }
  }, [time])

  return (
    <div className={`alert alert-${variant} mb-0`}>
      <h4 className="d-flex">
        <span className="mr-auto">{title}</span>
        <FontAwesomeIcon icon={['fas', 'times']} onClick={closeToast} />
      </h4>
      <p>{message}</p>
      <small className="Toastify-timestamp">{timestamp}</small>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  title: toastTitleSelector,
  message: toastMessageSelector,
  time: toastTimeSelector,
  variant: toastVariantSelector,
})

export default connect(mapStateToProps)(Toast)
